import { render, staticRenderFns } from "./CompletionsGraph.vue?vue&type=template&id=8b722be8"
import script from "./CompletionsGraph.vue?vue&type=script&lang=js"
export * from "./CompletionsGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports